import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Row, Col } from "react-bootstrap";
import { showError, showSuccess } from "ReduxErrorBar";
import { fetchPollResult } from "PollAction";
import { ProgressBar } from "react-bootstrap";
import LocaleStrings from "Languages";
import Button from "react-bootstrap-button-loader";

class ShowResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      option1: 0,
      option2: 0,
      option3: 0,
      option4: 0,
      totalCount: 0,
    };
  }

  componentDidMount() {}

  openModal = () => {
    let { pollResult } = this.props;
    let option1 = 0;
    let option2 = 0;
    let option3 = 0;
    let option4 = 0;
    let totalCount = 0;
    this.setState({ showModal: true });

    this.props.fetchPollResult(
      this.props.session,
      this.props.pollResult,
      (response) => {
        if (response.success) {
          option1 = response.result.option1;
          option2 = response.result.option2;
          option3 = response.result.option3;
          option4 = response.result.option4;
          totalCount = response.result.total;

          this.setState({ option1, option2, option3, option4, totalCount });
        }
      }
    );
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    let { pollResult } = this.props;
    let { option1, option2, option3, option4, totalCount } = this.state;

    let style3 = "poll-option-display";
    let style4 = "poll-option-display";
    if (!pollResult.option3 || pollResult.option3 == "") {
      style3 = "poll-option-hide";
    }
    if (!pollResult.option4 || pollResult.option4 == "") {
      style4 = "poll-option-hide";
    }

    var iconUrl = `../../style/images/poll-icons/poll-result.png`;

    return (
      <div>
        <button
          type="button"
          className="btn i-custom-table-edit"
          onClick={this.openModal}
        >
          <img className="i-custom-poll-result" src={iconUrl} />
        </button>
        <div>
          <Modal
            className="modal-container"
            show={this.state.showModal === true ? true : false}
            onHide={this.closeModal}
            animation={true}
            dialogClassName="poll-result-modal"
          >
            <Modal.Header>
              <div className="import-modal-title">
                {LocaleStrings.polls_qa_text_poll_result}
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.closeModal()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              {/* <div className="import-header">
                                <div className="import-modal-title">{LocaleStrings.polls_qa_text_poll_result}</div>
                                <button type="button" className="close btn-sm btn-close " onClick={() => this.closeModal()} style={{marginTop:-25}}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div> */}

              <div className="poll-result-question">{pollResult.question}</div>

              <div className="poll-total-count">
                <span>
                  {LocaleStrings.polls_qa_text_poll_result_total_count} :-{" "}
                </span>{" "}
                {totalCount}
              </div>

              <div className="poll-option-display">
                <span>{pollResult.option1}</span>
                <div className="d-flex" style={{marginTop:'6px'}}>
                  <ProgressBar now={option1} className="progress-main" />
                  <div style={{ paddingTop: 5, marginLeft: 17 }}>
                    {option1 == 33 ? (
                      <div>{option1}.3%</div>
                    ) : (
                      <div>{option1}%</div>
                    )}
                    {/* {option1}% */}
                  </div>
                </div>
              </div>
              <div className="poll-option-display" style={{marginTop:'6px'}}>
                <span>{pollResult.option2}</span>
                <div className="d-flex">
                  <ProgressBar now={option2} className="progress-main" />
                  <div style={{ paddingTop: 5, marginLeft: 17 }}>
                    {option2 == 33 ? (
                      <div>{option2}.3%</div>
                    ) : (
                      <div>{option2}%</div>
                    )}
                    {/* {option2}% */}
                  </div>
                </div>
              </div>
              <div className={style3}>
                <span>{pollResult.option3}</span>
                <div className="d-flex" style={{marginTop:'6px'}}>
                  <ProgressBar
                    now={option3}
                    variant="info"
                    className="progress-main"
                  />
                  <div style={{ paddingTop: 5, marginLeft: 17 }}>
                    {option3 == 33 ? (
                      <div>{option3}.3%</div>
                    ) : (
                      <div>{option3}%</div>
                    )}
                    {/* {option3}% */}
                  </div>
                </div>
              </div>
              <div className={style4}>
                <span>{pollResult.option4}</span>
                <div className="d-flex" style={{marginTop:'6px'}}>
                  <ProgressBar
                    now={option4}
                    variant="info"
                    className="progress-main"
                  />
                  <div style={{ paddingTop: 5, marginLeft: 17 }}>
                    {option4 == 33 ? (
                      <div>{option4}.3%</div>
                    ) : (
                      <div>{option4}%</div>
                    )}
                    {/* {option4}% */}
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-custom-white"
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  fetchPollResult,
  showError,
  showSuccess,
})(ShowResult);
